import { ArrowCircleRightIcon } from "@heroicons/react/outline";
import { HashtagIcon } from "@heroicons/react/solid";
import { serviceData, serviceDataTwo } from "../../utils/servicecard";

const ServiceCard = () => {
  return (
    <div className="lg:grid lg:grid-cols-2 lg:gap-5 pt-5">
      <div className="space-y-3 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-5">
        {serviceData.map((data, index) => (
          <div
            key={data.id}
            className="group space-y-2 bg-white p-3 rounded-md hover:scale-105  hover:transition-all transform duration-100 hover:ease-in-out hover:shadow-lg hover:cursor-pointer shadow-md"
          >
            <HashtagIcon
              className={`h-16 py-3 group-hover:text-indigo-500 ${
                index === 1 &&
                "border-2 border-gray-700 group-hover:border-indigo-500 px-3 rounded-lg"
              }`}
            />
            <div className=" group-hover:text-indigo-500">
              <h1 className="font-bold text-xl sm:text-2xl font-mono">
                {data.title}
              </h1>
              <p className="mt-3">{data.desc}</p>
            </div>
            <div className="flex justify-end pt-5 group-hover:text-indigo-500">
              <ArrowCircleRightIcon className="h-6 text-right" />
            </div>
          </div>
        ))}
      </div>
      <div className="sm:grid sm:grid-cols-2 sm:gap-5 pt-5 lg:pt-0 space-y-5 sm:space-y-0">
        {serviceDataTwo.map(({ id, title, Icon, Arrow }) => (
          <div
            className="group bg-white px-4 py-5 flex flex-col justify-around rounded-md hover:scale-105  hover:transition-all transform duration-100 hover:ease-in-out hover:shadow-lg hover:cursor-pointer shadow-md"
            key={id}
          >
            <div>
              <Icon className=" h-10 group-hover:text-indigo-500" />
            </div>

            <div className="flex items-center justify-between group-hover:text-indigo-500">
              <h1 className="text-lg font-bold font-mono">{title}</h1>
              <Arrow className="h-6" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCard;
